import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { TrendingUp, TrendingDown } from "lucide-react";

const fmt = (p, dec) => p.toLocaleString(undefined, { minimumFractionDigits: dec, maximumFractionDigits: dec });

const Ticker = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/market/ticker");
        if (alive) setItems(data.items);
      } catch { /* keep last */ }
    };
    load();
    const id = setInterval(load, 15000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (!items.length) return <div className="ticker" data-testid="price-ticker" />;

  const row = items.map((it) => {
    const up = it.change_pct >= 0;
    const Icon = up ? TrendingUp : TrendingDown;
    return (
      <span className="tk-item" key={it.label}>
        <b>{it.label}</b>
        <span className="tk-price">{fmt(it.price, it.dec)}</span>
        <span className={up ? "up" : "dn"}><Icon size={11} /> {up ? "+" : ""}{it.change_pct.toFixed(2)}%</span>
      </span>
    );
  });

  return (
    <div className="ticker" data-testid="price-ticker">
      <div className="tk-live"><i /> LIVE</div>
      <div className="tk-track">
        <div className="tk-move">{row}{row}</div>
      </div>
    </div>
  );
};

export default Ticker;
